import { ISector } from '@dm-portal/sector/Sector';
import IIndustry from '@/creditflowresearch/domain/vo/IIndustry';
import { IResearchDocumentGroup } from '@/creditflowresearch/domain/vo/research/IResearchDocumentGroup';
import { ISector as IApiSector } from '@/creditflowresearch/domain/vo/ISector';
import {
  IDictionaryDocumentTypeGroup,
  IDictionaryIndustry,
} from '@/creditflowresearch/domain/vo/IDictionary';

/**
 * @deprecated Use DictionaryRepository methods instead of these legacy mappers.
 */
export const transformSectors = (sectors: IApiSector[]): ISector[] => sectors.map((sector) => ({
  id: sector.id,
  name: sector.name,
  displayName: sector.displayName,
  abbreviation: sector.abbreviation,
  color: sector.color ?? '',
  beta: sector.beta,
  priority: sector.priority,
  subsectorList: sector.subsectors.map((subsector) => ({
    id: subsector.id,
    name: subsector.name,
    color: subsector.color ?? '',
    sectorId: sector.id,
    priority: subsector.priority,
  })),
}));

/**
 * @deprecated Use DictionaryRepository methods instead of these legacy mappers.
 */
export const transformIndustries = (industries: IDictionaryIndustry[]): IIndustry[] => industries.map((industry) => ({
  id: industry.id,
  name: industry.name,
  abbreviation: industry.abbreviation,
  color: industry.color ?? '',
  priority: industry.priority,
  subindustryList: industry.subindustries.map((subindustry) => ({
    id: subindustry.id,
    name: subindustry.name,
    displayName: subindustry.displayName,
    color: subindustry.color ?? '',
    industryId: industry.id,
    priority: subindustry.priority,
  })),
}));

/**
 * @deprecated Use DictionaryRepository methods instead of these legacy mappers.
 */
export const transformDocumentTypeGroups = (
  groups: IDictionaryDocumentTypeGroup[],
): IResearchDocumentGroup[] => groups.map((group) => ({
  groupId: group.id,
  groupName: group.name,
  documentTypeCollection: group.documentTypes.map((docType) => ({
    id: docType.id,
    originalDocumentType: docType.originalDocumentType ?? '',
    displayName: docType.displayName ?? '',
    parentId: docType.parentId ?? '',
    publisherId: docType.publisherId ?? '',
    position: docType.priority ?? 0,
  })),
}));
